// hero images from schema
const heroLeft = document.querySelector('.index__section-hero .e-hero-left')
const heroRight = document.querySelector('.index__section-hero .e-hero-right')
const mobileHeroImg = document.querySelector('.index__section-hero .m-img-container').dataset?.mobileHero
if(mobileHeroImg === 'one') {
    heroRight.classList.add('index__desktop')
} else if(mobileHeroImg === 'two') {
    heroLeft.classList.add('index__desktop')
}

// hero text flash
const heroText = document.querySelector('.index__section-hero .e-title')
const textFlash = heroText.dataset?.textFlash
const textFlashColor = heroText.dataset?.textFlashColor
if(textFlash === 'true') {
    setInterval(() => {
        if(heroText.style.color) {
            // heroText.style.transition = ''
            heroText.style.transition = 'color .3s ease-out'
            heroText.style.removeProperty('color')
        } else {
            // heroText.style.transition = 'color 1.8s ease-out'
            heroText.style.transition = ''
            heroText.style.color = textFlashColor
        }
    }, 1500)
}

// cta hover color from schema
const cta = document.querySelector('.index__section-hero .e-cta')
cta.addEventListener('mouseover', (e) => {
    e.target.style.color = e.target.dataset.hoverCtaColor
})
cta.addEventListener('mouseout', (e) => {
    e.target.style.color = e.target.dataset.ctaColor
})

// commas and colors for schema links
const heroLinks = document.querySelectorAll('.index__section-hero .m-nav-links a')
let linkCount = 1
heroLinks.forEach((link, i) => {
    if(linkCount === 1) {
        link.style.color = '#D58778'
        linkCount++
    } else if(linkCount === 2) {
        link.style.color = '#EC9E85'
        linkCount++
    } else {
        link.style.color = '#EBBAA3'
        linkCount = 1 
    }
    if(i !== heroLinks.length - 1) link.insertAdjacentHTML('beforeend', ',')
})